module.exports = __webpack_public_path__ + "img/cryptocurrencies-going-up.3967521f.png";